import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const formatCurrency = (value) => {
  if (value === '' || value === null || value === undefined || isNaN(value)) return '';
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);

  return formatted.replace('€', '€ ');
};

const VisitasTable = ({ visitas, openModal, setCurrentPage, currentPage }) => {
  // React.useEffect(() => {
  //   setCurrentPage(0);
  // }, [visitas]);
  // const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Ordenar visitas por FechaUltModificacionRegistro (más recientes primero)
  const visitasOrdenadas = [...visitas].sort((a, b) => {
    const fechaA = new Date(a.FechaUltModificacionRegistro || a.FechaCreacionRegistro || 0);
    const fechaB = new Date(b.FechaUltModificacionRegistro || b.FechaCreacionRegistro || 0);
    return fechaB - fechaA; // Orden descendente (más recientes primero)
  });

  const pageCount = Math.max(1, Math.ceil(visitasOrdenadas.length / itemsPerPage));
  const offset = currentPage * itemsPerPage;
  const currentVisitas = visitasOrdenadas.slice(offset, offset + itemsPerPage);

    // const handlePageClick = ({ selected }) => {
    // setCurrentPage(selected);
    // };


  return (
    <div className="w-full no-select bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
      {isMobile ? (
        <div className="p-3 sm:p-4 md:p-6">
          <div className="flex flex-col gap-3 sm:gap-4">
            {currentVisitas.map((visita) => (
            <div
              key={visita.IdOferta}
              className="group bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-sm border border-gray-200 hover:shadow-lg hover:border-blue-200 transition-all duration-300 cursor-pointer"
              onClick={() => openModal(visita)}
              title="Editar Visita"
            >
              {/* Header de la card */}
              <div className="flex items-start justify-between mb-3 sm:mb-4">
                <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
                  <div className="p-2 sm:p-3 bg-blue-50 rounded-lg sm:rounded-xl group-hover:bg-blue-100 transition-colors flex-shrink-0">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-gray-800 text-base sm:text-lg truncate">{visita.Comercial}</h3>
                    <p className="text-blue-600 font-medium text-sm truncate">{visita.Cliente}</p>
                  </div>
                </div>
                <div className="p-1.5 sm:p-2 bg-green-50 rounded-lg flex-shrink-0">
                  <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>

              {/* Información principal */}
              <div className="grid grid-cols-1 gap-2 sm:gap-3 mb-3 sm:mb-4">
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Oferta</span>
                  <span className="font-medium text-gray-800 text-sm truncate max-w-[60%] text-right">{visita.Oferta || '-'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Fecha</span>
                  <span className="font-medium text-gray-800 text-sm">{visita.FechaVisita ? new Date(visita.FechaVisita).toLocaleDateString('es-ES') : '-'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Importe</span>
                  <span className="font-semibold text-green-600 text-sm">{formatCurrency(visita.ImporteAproxOferta) || '-'}</span>
                </div>
              </div>

              {/* Badges y información adicional */}
              <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-2 sm:mb-3">
                <span className="inline-flex items-center px-2 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 truncate max-w-[45%]">
                  {visita.EstadoOferta || '-'}
                </span>
                <span className="inline-flex items-center px-2 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 truncate max-w-[45%]">
                  {visita.Segmento || '-'}
                </span>
              </div>

              {/* Footer con información adicional */}
              <div className="pt-2 sm:pt-3 border-t border-gray-100">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-2 text-xs text-gray-600">
                  <span className="truncate">Tipo: <span className="font-medium">{visita.TipoVisita || '-'}</span></span>
                  <span className="truncate">Potencial: <span className="font-medium">{visita.PotencialCliente || '-'}</span></span>
                </div>
                {visita.Comentarios && (
                  <div className="mt-1.5 sm:mt-2">
                    <span className="text-xs text-gray-500">Comentarios: </span>
                    <span className="text-xs text-gray-600 italic break-words">
                      {visita.Comentarios.length > 40
                        ? `${visita.Comentarios.slice(0, 40)}...`
                        : visita.Comentarios}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
          </div>
        </div>
      ) : (
        <div className="overflow-auto">
          <table className="min-w-[900px] table-auto bg-white border-spacing-0 w-full no-select">
            <thead className="sticky top-0 z-10 bg-gray-50 border-b border-gray-200">
              <tr className="bg-gradient-to-r from-blue-50 to-blue-100 border-b-2 border-blue-200">
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Comercial</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Cliente</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Oferta</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Fecha Visita</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Importe Aprox</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Tipo Visita</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Estado Oferta</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Segmento</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Potencial</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Comentarios</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentVisitas.map((visita, index) => (
                <tr
                  key={visita.IdOferta}
                  className={`cursor-pointer hover:bg-blue-50 group transition-colors duration-200 ${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  }`}
                  onClick={() => openModal(visita)}
                  title="Editar Visita"
                >
                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-medium text-gray-800 group-hover:text-blue-600">
                    {visita.Comercial || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-medium text-gray-800 group-hover:text-blue-600">
                    <div className="max-w-[150px] truncate" title={visita.Cliente || '-'}>
                      {visita.Cliente || '-'}
                    </div>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    <div className="max-w-[120px] truncate" title={visita.Oferta || '-'}>
                      {visita.Oferta || '-'}
                    </div>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {visita.FechaVisita ? new Date(visita.FechaVisita).toLocaleDateString('es-ES') : '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                    <span className='px-2 py-1 bg-green-100 text-green-800 rounded-lg text-xs font-medium'>
                      {formatCurrency(visita.ImporteAproxOferta) || '-'}
                    </span>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                    <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded-lg text-xs font-medium">
                      {visita.TipoVisita || '-'}                    
                    </span>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                      {visita.EstadoOferta || '-'}
                    </span>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {visita.Segmento || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {visita.PotencialCliente || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    <div className="max-w-[120px] truncate" title={visita.Comentarios || ''}>
                      {visita.Comentarios || '-'}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Paginación */}
      <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center sm:gap-3 sm:gap-4 p-3 sm:p-4 bg-gray-50 border-t border-gray-200">
        
        <div className="flex items-center gap-2 sm:gap-3 p-3 md:p-0">
          <label className="text-xs sm:text-sm font-medium text-gray-700">Items por página:</label>
          <div className="flex items-center gap-1">
            {[5, 10, 20].map(size => (
              <button
                key={size}
                onClick={() => {
                  setItemsPerPage(size);
                  setCurrentPage(0);
                }}
                className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 ${
                  itemsPerPage === size
                    ? 'bg-blue-600 text-white shadow-sm'
                    : 'bg-white text-gray-700 border border-gray-200 hover:bg-blue-50 hover:border-blue-300'
                }`}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 p-1 md:p-0">
          <button 
            onClick={() => setCurrentPage(0)} 
            disabled={currentPage === 0} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 shadow-sm"
          >
            <ChevronsLeft size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
          <button 
            onClick={() => setCurrentPage((prev) => prev - 1)} 
            disabled={currentPage === 0} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 shadow-sm"
          >
            <ChevronLeft size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
          
          <span className="px-2 sm:px-4 py-1.5 sm:py-2 bg-blue-50 border border-blue-200 rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium text-blue-800">
            {currentPage + 1} / {pageCount}
          </span>
          
          <button 
            onClick={() => setCurrentPage((prev) => prev + 1)} 
            disabled={currentPage >= pageCount - 1} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 shadow-sm"
          >
            <ChevronRight size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
          <button 
            onClick={() => setCurrentPage(pageCount - 1)} 
            disabled={currentPage >= pageCount - 1} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-blue-50 hover:border-blue-300 transition-all duration-200 shadow-sm"
          >
            <ChevronsRight size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VisitasTable;
